// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".groupObjectDetails[data-v-41093c62]{height:100%;padding:10px;font-size:12px!important;color:#080707!important;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.groupObjectDetails .groupObjectDetailsLeft[data-v-41093c62]{width:220px;background-color:#fff;border-radius:3px}.groupObjectDetails .dynamic-public[data-v-41093c62]{width:calc(100% - 230px);border-radius:3px;margin-left:10px;background-color:#fff;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
